import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import c from 'classnames';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';

import { WEBFORM_TYPES } from '../../../../config/constants';
import { WebformContext, type WebformContextProps } from '../../../../context/WebformContext';
import type { WebformState } from '../../types';

import './style.scss';

export interface WebformAssessmentWrapperProps {
  id: string;
  children: React.ReactNode;
  className?: string;
}

const WebformAssessmentWrapper: React.FC<WebformAssessmentWrapperProps> = (props) => {
  const { id, children, className } = props;

  const revealComponent = useRef<HTMLDivElement>(null);

  const [currentPage, setCurrentPage] = useState('');
  const [currentElement, setCurrentElement] = useState('');

  const pages = useSelector<WebformState, string[]>(
    (state) => {
      const fields = state.getIn(['webform', id, 'fields'], Immutable.Map());
      const wizardPages = fields.filter((field) => field.get('#type') === WEBFORM_TYPES.WEBFORM_WIZARD_PAGE);
      return wizardPages.keySeq().toJS();
    },
  );

  const webformContext = useMemo((): WebformContextProps => ({
    id,
    pages,
    currentPage,
    currentElement,
    updateCurrentPage: setCurrentPage,
    updateCurrentElement: setCurrentElement,
  }), [currentElement, currentPage, id, pages]);

  const classNames = c('WebformAssessment__Wrapper', className);

  useEffect(() => {
    if (revealComponent.current && revealComponent.current.classList) {
      revealComponent.current.classList.remove('WebformAssessment__Wrapper__reveal--hidden');
    }
  });

  return (
    <WebformContext.Provider value={webformContext}>
      <div className={classNames}>
        <div ref={revealComponent} className="WebformAssessment__Wrapper__reveal WebformAssessment__Wrapper__reveal--hidden" />
        {children}
      </div>
    </WebformContext.Provider>
  );
};

export default WebformAssessmentWrapper;
